import { UserType, UserTypes, UserTypesLetters } from "../types/user"
import MOLocation from "./MOLocation"

export const getUserTypeByUrl = (): UserTypes => {
  const roomHashUrl = MOLocation.getQueryParams().roomHash
  const letterTypeFromUrl = roomHashUrl?.[5] as UserTypesLetters

  switch (letterTypeFromUrl) {
    case "b": {
      return UserType.BROADCASTER
    }
    case "m": {
      return UserType.MODERATOR
    }
    default: {
      return UserType.AUDIENCE
    }
  }
}

export const getUserTypeByUrlV2 = (): UserTypes => {
  const roomHashUrl = MOLocation.getQueryParamsV2().roomHash
  const letterTypeFromUrl = roomHashUrl?.[5] as UserTypesLetters

  switch (letterTypeFromUrl) {
    case "b": {
      return UserType.BROADCASTER
    }
    case "m": {
      return UserType.MODERATOR
    }
    default: {
      return UserType.AUDIENCE
    }
  }
}
